import { render, staticRenderFns } from "./data404.vue?vue&type=template&id=17b2ae76&scoped=true&"
import script from "./data404.vue?vue&type=script&lang=js&"
export * from "./data404.vue?vue&type=script&lang=js&"
import style0 from "./data404.vue?vue&type=style&index=0&id=17b2ae76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2ae76",
  null
  
)

export default component.exports